import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../../../widgets/components/UI/InfoCard2'
import { Formik } from 'formik'
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react'
import TextInput from '../../../../widgets/components/Input/TextInput'
import SelectSearchInput from '../../../../widgets/components/Input/SelectSearchInput'
import deleteicon from '../../../../../../media/stakeholders/ic-delete.svg'
import { ToolTipUIForModal } from '../../../../widgets/components/UI/ToolTipUIForModal'
import { SelectInput } from '../../../../widgets/components/Input/SelectInput'
import { useCurrency } from '../../../../../hooks/useCurrency'
import {
  accuralPeriodOptions,
  compoundingMethodOptions,
  convertibleTypesOptions,
  participatingOptions,
  seniorityOptions,
  TransactionModals,
  valuationCapOptions,
} from '../../core/_constants'
import { useAuth } from '../../../../auth'
import * as Yup from 'yup'
import { useGetAllSecurityClassesDropdown } from '../../../../../hooks/useGetAllSecurityClassesDropdown'
import { SecurityClassDropdown } from '../../../components/security-class-dropdown'
import {
  createConvertibleSecurityClass,
  getConvertibleSecurityClassById,
  updateConvertibleSecurityClass,
} from '../../core/_requests'
import { toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton'
import { getFileType } from '../../../../../core/_util'
import { FileUpload } from '../../../../widgets/components/FileUpload'
import { allowedFileTypes } from '../../../../../core/_constants'
import { DeleteFileConfirmationModal } from '../../../components/delete-file-confirmation-modal'
import { TransactionModalType } from '../../core/_models'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../../hooks/gtmHelpers'
import { useStakeholders } from '../../../Stakeholders'
import { format } from 'date-fns'
import brandingConfig from '../../../../../../config/brandingConfig'

export default function AddConvertibleClassModal({
  isActive,
  setIsActive,
  convertibleClassId,
  setIsConvertibleCreateOrUpdate,
  setSidebar,
  openModal,
  setIsShareClassDropdown,
  setModalType,
  setIsCreate,
  modalType,
  convertibleClassDropdown,
  setConvertibleClassDropdown,
}: {
  isActive: boolean
  setIsActive: () => void
  convertibleClassId?: string | null
  setIsConvertibleCreateOrUpdate: Dispatch<SetStateAction<boolean>>
  setSidebar: Dispatch<SetStateAction<number>>
  setIsShareClassDropdown: Dispatch<SetStateAction<boolean>>
  openModal: (modalType: TransactionModalType) => void
  setModalType: Dispatch<SetStateAction<TransactionModalType>>
  setIsCreate: Dispatch<SetStateAction<boolean>>
  modalType?: TransactionModalType
  convertibleClassDropdown?: boolean
  setConvertibleClassDropdown?: Dispatch<SetStateAction<boolean>>
}) {
  const { formatMessage } = useIntl()
  const [currentDocumentStep, setCurrentDocumentStep] = useState(1)
  const { currencyOptions } = useCurrency()
  const [isNotInitialized, setIsNotInitiaized] = useState(true)
  const [modelStatus, setModelStatus] = useState(false)
  const fileRef = useRef<any>([])
  const [convertibleClassDetailsLoading, setConvertibleClassDetailsLoading] = useState(false)
  const [convertibleSecurityClassDetails, setConversibleSecurityClassDetails] = useState<any>(null)
  const { companyId, currentUser } = useAuth()
  const [isLoading, setLoading] = useState(false)
  const [deleteFileId, setDeleteFileId] = useState<any>(null)
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const {
    createdShareClassFromOtherClasses,
    createdShareClassEditConvertibleClassId,
    setCreatedConvetibleClassFromOtherTransaction,
  } = useStakeholders()

  const { shareSecuirtyClassDropdownData, shareSecuirtyDropdownDataLoading } =
    useGetAllSecurityClassesDropdown(TransactionModals.ADD_CONVERTIBLE_CLASS_MODAL)

  const { companyCurrency } = useAuth()
  const validationSchema = [
    Yup.object().shape({
      convertibleType: Yup.object().nullable().required('Class type is required'),
      className: Yup.string()
        .nullable()
        .required('Class name is required')
        .max(30, 'Class name must not exceed 30 characters'),
      classCode: Yup.string()
        .nullable()
        .required('Class code is required')
        .max(30, 'Class code must not exceed 30 characters'),
      tagColor: Yup.string().nullable().required('Tag color is required'),
      shareClassId: Yup.object().nullable().required('Share class is required'),
      issueDate: Yup.string()
        .nullable()
        .required('Issue date is required')
        .test('date', 'Invalid date', (value: any, ctx: any) => {
          const firstClosingDate = ctx.parent.shareClassId?.firstClosingDate

          // Check if both dates are valid before formatting
          const isFirstClosingDateValid =
            firstClosingDate && !isNaN(new Date(firstClosingDate).getTime())
          const isValueValid = value && !isNaN(new Date(value).getTime())

          if (isFirstClosingDateValid && isValueValid) {
            const formattedFirstClosingDate = format(firstClosingDate, 'yyyy-MM-dd')
            const formattedValue = format(value, 'yyyy-MM-dd')

            if (formattedFirstClosingDate > formattedValue) {
              console.log('here')
              return false
            }
          }

          return true
        }),
      maturity: Yup.number()
        .nullable()
        .required('Maturity date is required')
        .min(0, 'Maturity must be a positive number')
        .test('max-length', 'Maturity must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
    }),
    Yup.object().shape({
      valuationCapType: Yup.object().nullable().required('Valuation cap type is required'),
      valuationCap: Yup.number()
        .nullable()
        .required('Valuation cap is required')
        .min(0, 'ValuationCap must be a positive number')
        .test('max-length', 'ValuationCap must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
      valuationFloor: Yup.number()
        .nullable()
        .min(0, 'Valuation floor must be a positive number')
        .test('max-length', 'Valuation floor must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
      conversionDiscount: Yup.number()
        .nullable()
        .min(0, 'Conversion discount must be a positive number')
        .test('max-length', 'Conversion discount must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
      conversionTrigger: Yup.number()
        .nullable()
        .min(1, "Conversion trigger cann't be negative or 0")
        .test('max-length', 'Conversion trigger must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
      rate: Yup.number()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value)) // Convert empty strings to null
        .min(0, 'Rate must be a positive number')
        .test('max-length', 'Rate must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
    }),
    Yup.object().shape({
      seniorityLevel: Yup.object().nullable().required('Seniority level is required'),
      multiplier: Yup.number()
        .nullable()
        .required('Multiplier is required')
        .min(0, 'Multiplier must be a positive number')
        .test('max-length', 'Muntiplier must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
      redemptionRate: Yup.number()
        .nullable()
        .min(0, 'RedemptionRate must be a positive number')
        .test('max-length', 'Conversion trigger must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
      participatingCap: Yup.number()
        .nullable()
        .min(0, 'Participating cap must be a positive number')
        .test('max-length', 'Participating cap  must not exceed 20 characters', (value) =>
          value ? value.toString().length <= 20 : true
        ),
    }),
  ]
  const formikRef = useRef<any>(null)
  const [currentSchema, setCurrentSchema] = useState(validationSchema[0])

  const initialValues = {
    convertibleType: convertibleSecurityClassDetails?.convertibleType
      ? convertibleTypesOptions.find(
        (option) => option.value === convertibleSecurityClassDetails?.convertibleType
      )
      : null,
    className: convertibleSecurityClassDetails?.className || null,
    classCode: convertibleSecurityClassDetails?.classCode || null,
    tagColor: convertibleSecurityClassDetails?.tagColor || '#F56767',
    shareClassId: createdShareClassFromOtherClasses
      ? shareSecuirtyClassDropdownData.find(
        (shareSecurityClass) => shareSecurityClass.id === createdShareClassFromOtherClasses
      )
      : convertibleSecurityClassDetails?.shareClassId
        ? shareSecuirtyClassDropdownData.find(
          (shareSecurityClass) =>
            shareSecurityClass.id === convertibleSecurityClassDetails?.shareClassId
        )
        : null,
    currency:
      currencyOptions.find((currencyId) => currencyId?.name?.split(' ')[0] === companyCurrency)
        ?.value ?? null,
    issueDate: convertibleSecurityClassDetails?.issueDate ?? null,
    maturity: convertibleSecurityClassDetails?.maturity ?? null,
    valuationCapType: convertibleSecurityClassDetails?.valuationCapType
      ? valuationCapOptions.find(
        (option) => option.value === convertibleSecurityClassDetails?.valuationCapType
      )
      : null,
    valuationFloorType: convertibleSecurityClassDetails?.valuationFloorType
      ? valuationCapOptions.find(
        (option) => option.value === convertibleSecurityClassDetails?.valuationFloorType
      )
      : null,

    valuationCap: convertibleSecurityClassDetails?.valuationCap ?? null,
    valuationFloor: convertibleSecurityClassDetails?.valuationFloor ?? null,
    conversionDiscount: convertibleSecurityClassDetails?.conversionDiscount ?? null,
    conversionTrigger: convertibleSecurityClassDetails?.conversionTrigger ?? null,
    convertibleInterestRate: convertibleSecurityClassDetails?.convertibleInterestRate ?? 'yes',
    rate: convertibleSecurityClassDetails?.rate ?? null,
    accuralPeriod: convertibleSecurityClassDetails?.accrualPeriod
      ? accuralPeriodOptions.find(
        (option) => option.value === convertibleSecurityClassDetails?.accrualPeriod
      )
      : null,
    compoundingMethod: convertibleSecurityClassDetails?.compoundingMethod
      ? compoundingMethodOptions.find(
        (option) => option.value === convertibleSecurityClassDetails?.compoundingMethod
      )
      : null,
    seniorityLevel: convertibleSecurityClassDetails?.seniorityLevel
      ? seniorityOptions.find(
        (option) => option.value === convertibleSecurityClassDetails?.seniorityLevel
      )
      : null,
    multiplier: convertibleSecurityClassDetails?.multiplier ?? null,
    participatingCap: convertibleSecurityClassDetails?.participatingCap ?? null,
    convertible: convertibleSecurityClassDetails?.convertible
      ? participatingOptions.find(
        (option) => option.value === convertibleSecurityClassDetails?.convertible
      )
      : null,
    redemptionInterestRate: convertibleSecurityClassDetails?.redemptionInterestRate ?? 'yes',
    redemptionRate: convertibleSecurityClassDetails?.redemptionRate ?? null,
    redemptionAccrualPeriod: convertibleSecurityClassDetails?.redemptionAccrualPeriod
      ? accuralPeriodOptions.find(
        (option) => option.value === convertibleSecurityClassDetails?.redemptionAccrualPeriod
      )
      : null,
    redemptionCompoundingMethod: convertibleSecurityClassDetails?.redemptionCompoundingMethod
      ? compoundingMethodOptions.find(
        (option) => option.value === convertibleSecurityClassDetails?.redemptionCompoundingMethod
      )
      : null,
    fileIds:
      convertibleSecurityClassDetails?.documents?.map((document: any) => document.fileId) || [],
  }

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const rawPayload = {
      convertibleType: values?.convertibleType?.value || values?.convertibleType?.id,
      className: values?.className,
      classCode: values?.classCode,
      tagColor: values?.tagColor,
      shareClassId: values?.shareClassId?.value || values?.shareClassId?.id,
      currency: values?.currency?.value || values?.currency?.id,
      issueDate: values?.issueDate,
      maturity: parseInt(values?.maturity),
      valuationCapType: values?.valuationCapType?.value || values?.valuationCapType?.id,
      valuationFloorType: values?.valuationFloorType?.value || values?.valuationFloorType?.id,
      valuationCap: parseInt(values?.valuationCap),
      valuationFloor: parseInt(values?.valuationFloor),
      conversionDiscount: parseInt(values?.conversionDiscount),
      conversionTrigger: parseInt(values?.conversionTrigger),
      convertibleInterestRate: values?.convertibleInterestRate, // Assuming this is a string
      rate: parseInt(values?.rate),
      accrualPeriod: values?.accuralPeriod?.value || values?.accuralPeriod?.id,
      compoundingMethod: values?.compoundingMethod?.value || values?.compoundingMethod?.id,
      seniorityLevel: values?.seniorityLevel?.value || values?.seniorityLevel?.id,
      multiplier: parseInt(values?.multiplier),
      participatingCap: parseInt(values?.participatingCap),
      convertible: values?.convertible?.value || values?.convertible?.id,
      redemptionInterestRate: values?.redemptionInterestRate, // Assuming this is a string
      redemptionRate: parseInt(values?.redemptionRate),
      redemptionAccrualPeriod:
        values?.redemptionAccrualPeriod?.value || values?.redemptionAccrualPeriod?.id,
      redemptionCompoundingMethod:
        values?.redemptionCompoundingMethod?.value || values?.redemptionCompoundingMethod?.id,
      fileIds: values?.fileIds,
    }

    const payload = Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, value]) =>
          value !== null &&
          value !== undefined &&
          value !== '' &&
          (!isNaN(value) || typeof value === 'string' || Array.isArray(value))
      )
    )

    try {
      if (!companyId) {
        return
      }
      setLoading(true)
      if (
        (convertibleClassId && convertibleSecurityClassDetails) ||
        (createdShareClassEditConvertibleClassId && convertibleSecurityClassDetails)
      ) {
        const {
          data: { data, success, errors },
        } = await updateConvertibleSecurityClass(
          payload,
          companyId,
          createdShareClassEditConvertibleClassId
            ? createdShareClassEditConvertibleClassId
            : convertibleClassId!
        )

        if (success) {
          resetForm()
          setFiles([])
          setConversibleSecurityClassDetails(null)
          setIsConvertibleCreateOrUpdate(true)
          if (convertibleClassDropdown) {
            if (setConvertibleClassDropdown) {
              if (openModal) {
                if (modalType === 'AddConvertibleTransaction') {
                  setCreatedConvetibleClassFromOtherTransaction(data.convertibleClassId)
                  openModal('AddConvertibleTransaction')
                }
                if (setModalType) {
                  setModalType('none')
                }
              }
              setConvertibleClassDropdown(false)
              setSidebar(2)
            }
          } else {
            setIsActive()
            setSidebar(2)
          }
          setLoading(false)
          toast.success(formatMessage({ id: 'Convertible security class updated successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ConvertibleSecurityClassUpdateSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                convertible_security_class_details: data,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ConvertibleSecurityClassUpdateFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      } else {
        const {
          data: { data, success, errors },
        } = await createConvertibleSecurityClass(payload, companyId)

        if (success) {
          toast.success(formatMessage({ id: 'Convertible security class created successfully' }))
          resetForm()
          setFiles([])
          setConversibleSecurityClassDetails(null)
          setLoading(false)

          setIsConvertibleCreateOrUpdate(true)

          if (convertibleClassDropdown) {
            if (setConvertibleClassDropdown) {
              if (openModal) {
                if (modalType === 'AddConvertibleTransaction') {
                  setCreatedConvetibleClassFromOtherTransaction(data.convertibleClassId)
                  openModal('AddConvertibleTransaction')
                }
                if (setModalType) {
                  setModalType('none')
                }
              }
              setConvertibleClassDropdown(false)
              setSidebar(2)
            }
          } else {
            setIsActive()
            setSidebar(2)
          }
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ConvertibleSecurityClassAddSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                convertible_security_class_details: data,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ConvertibleSecurityClassAddFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.error('Error:', err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.ConvertibleSecurityClassAddFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (convertibleSecurityClassDetails?.documents.length > 0 && isNotInitialized) {
      setFiles(
        convertibleSecurityClassDetails?.documents.map(
          ({ fileId, name }: { fileId: string; name: string }) => ({
            id: fileId,
            name,
          })
        )
      )
    }
  }, [isNotInitialized, convertibleSecurityClassDetails?.documents]) // eslint-disable-line react-hooks/exhaustive-deps

  const nextStep = async () => {
    if (currentDocumentStep === 1) {
      await setCurrentSchemaAsync(validationSchema[1])
      if (formikRef.current) {
        await formikRef.current.validateForm()
      }
    } else if (currentDocumentStep === 2) {
      await setCurrentSchemaAsync(validationSchema[2])

      if (formikRef.current) {
        await formikRef.current.validateForm()
      }
    }
    setCurrentDocumentStep((prev) => prev + 1)
  }

  // Helper function to turn setCurrentSchema into an async function
  const setCurrentSchemaAsync = async (newSchema: any) => {
    return new Promise<void>((resolve) => {
      setCurrentSchema(newSchema)
      resolve()
    })
  }

  const prevStep = async () => {
    if (currentDocumentStep > 1) {
      if (currentDocumentStep === 4) {
        await setCurrentSchemaAsync(validationSchema[2])
      } else if (currentDocumentStep === 3) {
        await setCurrentSchemaAsync(validationSchema[1])
      } else if (currentDocumentStep === 2) {
        await setCurrentSchemaAsync(validationSchema[0])
      }

      // After updating the schema, revalidate the form to apply the new schema's rules
      if (formikRef.current) {
        formikRef.current.validateForm()
      }

      // After schema update, update the step
      setCurrentDocumentStep((prev) => prev - 1)
    }
  }

  // Helper function to wrap setCurrentSchema as an async function

  const [files, setFiles] = useState<any>([])

  const deleteFile = () => {
    if (!deleteFileId) return
    setDeleteLoading(true)
    setFiles(files.filter((file: any) => file.id !== deleteFileId))
    if (formikRef.current) {
      formikRef.current.setFieldValue(
        'fileIds',
        files.filter((file: any) => file.id !== deleteFileId).map((file: any) => file.id)
      )
    }
    toast.success('Document deleted successfully')
    setDeleteLoading(false)
    setDeleteShowModal(false)
  }

  const fetchConvertibleSecurityClassDetails = async () => {
    if (!(convertibleClassId || createdShareClassEditConvertibleClassId)) return
    setConvertibleClassDetailsLoading(true)
    try {
      const {
        data: { success, data },
      } = await getConvertibleSecurityClassById(
        companyId!,
        createdShareClassEditConvertibleClassId
          ? createdShareClassEditConvertibleClassId
          : convertibleClassId!
      )
      if (success && data) {
        setConversibleSecurityClassDetails(data)
        setSelectedColor(data?.tagColor)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setConvertibleClassDetailsLoading(false)
    }
  }

  useEffect(() => {
    fetchConvertibleSecurityClassDetails()
  }, [convertibleClassId, createdShareClassEditConvertibleClassId]) // eslint-disable-line react-hooks/exhaustive-deps

  // select colour

  const [selectedColor, setSelectedColor] = useState('#F56767')
  const colors = [
    { color: '#F56767', id: 'red' },
    { color: '#AA72E8', id: 'purple' },
    { color: '#B30B30', id: 'darkRed' },
    { color: '#FF66FF', id: 'pink' },
    { color: '#66CC66', id: 'green' },
    { color: '#FFD700', id: 'yellow' },
    { color: '#3399FF', id: 'blue' },
  ]

  const handleColorClick = (color: any) => {
    if (formikRef.current) {
      formikRef.current.setFieldValue('tagColor', color)
    }
    setSelectedColor(color)
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={currentSchema}
        innerRef={formikRef}
        validateOnMount={true}
        validateOnChange
        isInitialValid={true}
        validateOnBlur
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <Modal show={isActive} onHide={() => setIsActive()} size='lg' fullscreen>
                <Modal.Header closeButton>
                  <h2>
                    {formatMessage({
                      id: convertibleClassId ? 'Edit Convertible Class' : 'Add Convertible Class',
                    })}
                  </h2>
                </Modal.Header>
                <Modal.Body className='container'>
                  <div
                    className='stepper stepper-pills stepper-column d-flex flex-column'
                    id='kt_create_account_stepper'
                  >
                    <div className='d-flex justify-content-start flex-column w-100'>
                      <div className='card-body px-0 d-flex justify-content-start'>
                        <div
                          className='d-flex gap-6 align-items-center'
                          style={{
                            overflowX: 'auto',
                            whiteSpace: 'nowrap',
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                          }}
                        >
                          {[1, 2, 3, 4].map((step) => (
                            <div
                              key={step}
                              className={`stepper-item ${currentDocumentStep === step ? 'current' : ''
                                }`}
                              style={{ display: 'inline-block' }}
                            >
                              <div className='stepper-wrapper'>
                                <div className='stepper-icon w-40px h-40px'>
                                  <i className='stepper-check'></i>
                                  <span className='stepper-number'>{step}</span>
                                </div>
                                <div className='stepper-label'>
                                  <h3 className='stepper-title fw-semibold font-size-13'>
                                    {formatMessage({
                                      id:
                                        step === 1
                                          ? 'Step 1'
                                          : step === 2
                                            ? 'Step 2'
                                            : step === 3
                                              ? 'Step 3'
                                              : 'Step 4',
                                    })}
                                  </h3>
                                  <div className='stepper-desc font-size-12'>
                                    {formatMessage({
                                      id:
                                        step === 1
                                          ? 'Basic Details'
                                          : step === 2
                                            ? 'Conversion Parameters'
                                            : step === 3
                                              ? 'Redemption Parameters'
                                              : 'Documents',
                                    })}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className='d-flex flex-column justify-content-between'>
                      <div className=''>
                        {/* Step 1 */}
                        {currentDocumentStep === 1 && (
                          <div className='w-100'>
                            <InfoCard2
                              title={formatMessage({ id: 'How to Add Convertible Class?' })}
                              desc={formatMessage({
                                id: `Add detailed Convertible Class information, including class type, name, prefix, conversion parameters, redemption parameters, and documents. These details help manage your cap table and investors more effectively on the ${brandingConfig.brandName} portal.`,
                              })}
                              slug={brandingConfig.helpLinks.addConvertibleClass}
                              className='w-100 mb-0'
                            />

                            <div className='mb-4'>
                              {convertibleClassDetailsLoading ? (
                                <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                                  <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                    <div className='col-md-5 mb-10 mb-md-0'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                    <div className='col-md-5'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                    <div className='col-md-5 mb-10 mb-md-0'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                    <div className='col-md-5'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                    <div className='col-md-5 mb-10 mb-md-0'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                    <div className='col-md-5'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                    <div className='col-md-5 mb-10 mb-md-0'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                    <div className='col-md-5'>
                                      <div className='w-50'>
                                        <Skeleton
                                          height={20}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                      <div className='mt-2'>
                                        <Skeleton
                                          height={30}
                                          baseColor='var(--kt-skeleton-bg-color)'
                                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className='w-100 mt-10'>
                                  <div className='row'>
                                    <div className='col-md-6 col-12'>
                                      <SecurityClassDropdown
                                        buttonLabel={formatMessage({ id: 'Add New Share Class' })}
                                        label={formatMessage({ id: 'Share Class' })}
                                        fieldName='shareClassId'
                                        toolTipText={formatMessage({
                                          id: 'Select class name of share security class',
                                        })}
                                        loading={shareSecuirtyDropdownDataLoading}
                                        options={shareSecuirtyClassDropdownData}
                                        formik={formik}
                                        placeholder={formatMessage({ id: 'Select Share Class' })}
                                        isTooltipForModal={true}
                                        ariaLabel='className'
                                        isPopulateData={true}
                                        onButtonClick={() => {
                                          setIsCreate(true)
                                          setModalType('AddConvertibleClassModal')
                                          setIsShareClassDropdown(true)
                                          openModal('AddSecurityClassModal')
                                        }}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <SelectSearchInput
                                        label={formatMessage({ id: 'Convertible Type' })}
                                        fieldName='convertibleType'
                                        placeholder={formatMessage({
                                          id: 'Select the Convertible Type',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'Select the type of Convertible Class that you are creating.',
                                        })}
                                        options={convertibleTypesOptions}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='text'
                                        label={formatMessage({ id: 'Convertible Class Name' })}
                                        fieldName='className'
                                        formik={formik}
                                        placeholder={formatMessage({
                                          id: 'Enter Convertible Class Name',
                                        })}
                                        toolTipText={formatMessage({
                                          id: 'Add a name to the Convertible Class you are creating.',
                                        })}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='text'
                                        label={formatMessage({ id: 'Convertible Class Prefix' })}
                                        fieldName='classCode' // Updated to match initialValues
                                        formik={formik}
                                        placeholder={formatMessage({
                                          id: 'Enter Convertible Class Prefix',
                                        })}
                                        toolTipText={formatMessage({
                                          id: 'Add a prefix to the Convertible Class name.',
                                        })}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>

                                    <div className='col-md-6 col-12'>
                                      <SelectInput
                                        label={formatMessage({ id: 'Currency' })}
                                        fieldName='currency'
                                        placeholder={formatMessage({
                                          id: 'Select Currency',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'GLOBAL.TOOLTIP.SECURITY_CLASS.ADD_SHARED_CLASS.CLASS_CURRENCY',
                                        })}
                                        options={currencyOptions}
                                        isTooltipForModal={true}
                                        disabled={true}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12 mb-8'>
                                      <div className='d-flex'>
                                        <label className='form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                          {formatMessage({ id: 'Select Tag Color *' })}
                                        </label>
                                        <ToolTipUIForModal tooltipText='Select a colour that will be used to represent this Convertible Class on {brandingConfig.brandName}.' />
                                      </div>
                                      <div className='d-flex align-items-center'>
                                        {colors.map((colorObj) => (
                                          <div
                                            key={colorObj.id}
                                            onClick={() => handleColorClick(colorObj.color)}
                                            className='me-2 rounded-circle mt-1'
                                            style={{
                                              backgroundColor: colorObj.color,
                                              width: '30px',
                                              height: '30px',
                                              border:
                                                selectedColor === colorObj.color
                                                  ? '3px solid black'
                                                  : 'none',
                                              cursor: 'pointer',
                                            }}
                                          />
                                        ))}
                                      </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='date'
                                        label={formatMessage({ id: 'Issue Date' })}
                                        fieldName='issueDate'
                                        formik={formik}
                                        placeholder={formatMessage({ id: 'Enter Issue Date' })}
                                        toolTipText={formatMessage({
                                          id: 'Specify the date on which shares for this Convertible Class were issued.',
                                        })}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        isDateOfBirth={true}
                                        isLesserThanShareClassFirstClosingDate={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Maturity (in months)' })}
                                        fieldName='maturity'
                                        formik={formik}
                                        placeholder={formatMessage({
                                          id: 'Enter Maturity (in months)',
                                        })}
                                        toolTipText={formatMessage({
                                          id: 'Specify the maturity period (in number of months) for this Convertible Class.',
                                        })}
                                        isTooltipForModal={true}
                                        isStarRequired={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* Step 2 */}
                        {currentDocumentStep === 2 && (
                          <div className='w-100'>
                            <InfoCard2
                              title={formatMessage({ id: 'How to Add Convertible Class?' })}
                              desc={formatMessage({
                                id: `Add detailed Convertible Class information, including class type, name, prefix, conversion parameters, redemption parameters, and documents. These details help manage your cap table and investors more effectively on the ${brandingConfig.brandName} portal.`,
                              })}
                              slug={brandingConfig.helpLinks.addConvertibleClass}
                              className='w-100 mb-0'
                            />

                            <div className='mb-4'>
                              <div className='w-100 mt-10'>
                                {convertibleClassDetailsLoading ? (
                                  <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className='row'>
                                    <div className='col-md-6 col-12'>
                                      <SelectSearchInput
                                        label={formatMessage({ id: 'Valuation Cap Type' })}
                                        fieldName='valuationCapType'
                                        placeholder={formatMessage({
                                          id: 'Valuation Cap Type',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'Select the Valuation Cap Type for this Convertible Class.',
                                        })}
                                        options={valuationCapOptions}
                                        isTooltipForModal={true}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Valuation Cap' })}
                                        fieldName='valuationCap'
                                        formik={formik}
                                        placeholder={formatMessage({ id: 'Enter Valuation Cap' })}
                                        toolTipText={formatMessage({
                                          id: 'Add the valuation cap for this Convertible Class.',
                                        })}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <SelectSearchInput
                                        label={formatMessage({ id: 'Valuation Floor Type' })}
                                        fieldName='valuationFloorType'
                                        placeholder={formatMessage({
                                          id: 'Valuation Floor Type',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'Select the Valuation Floor Type for this Convertible Class.',
                                        })}
                                        options={valuationCapOptions}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Valuation Floor' })}
                                        fieldName='valuationFloor'
                                        formik={formik}
                                        placeholder={formatMessage({ id: 'Enter Valuation Floor' })}
                                        toolTipText={formatMessage({
                                          id: 'Add valuation floor for this Convertible Class.',
                                        })}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Conversion Discount (%)' })}
                                        fieldName='conversionDiscount'
                                        formik={formik}
                                        placeholder={formatMessage({
                                          id: 'Enter Conversion Discount (%)',
                                        })}
                                        toolTipText={formatMessage({
                                          id: 'Add the percentage of discount offered in this Convertible Class.',
                                        })}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Conversion Trigger' })}
                                        fieldName='conversionTrigger'
                                        formik={formik}
                                        placeholder={formatMessage({
                                          id: 'Enter Conversion Trigger',
                                        })}
                                        toolTipText={formatMessage({
                                          id: 'Add conversion trigger for this Convertible Class.',
                                        })}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className=''>
                                      <div className='d-md-flex flex-md-column  mb-8 px-3 px-md-0'>
                                        <div className='d-flex form-label  text-dark font-size-13'>
                                          {formatMessage({ id: 'Convertible Interest Rate' })}{' '}
                                          <ToolTipUIForModal
                                            tooltipText={formatMessage({
                                              id: 'Specify if conversion interest rate is applicable to this Convertible Class or not.',
                                            })}
                                          />
                                        </div>
                                        <div className='d-flex align-items-center gap-4'>
                                          <div className='d-flex align-items-center gap-1'>
                                            <input
                                              type='radio'
                                              id='yes'
                                              checked={
                                                formik.values.convertibleInterestRate === 'yes'
                                              }
                                              name='convertibleInterestRate'
                                              onChange={formik.handleChange}
                                              value='yes'
                                              width={48}
                                              height={48}
                                            />
                                            <label htmlFor='yes'>
                                              {formatMessage({ id: 'Yes' })}
                                            </label>
                                          </div>
                                          <div className='d-flex align-items-center gap-1'>
                                            <input
                                              type='radio'
                                              id='no'
                                              name='convertibleInterestRate'
                                              checked={
                                                formik.values.convertibleInterestRate === 'no'
                                              }
                                              onChange={(e) => {
                                                formik.handleChange(e)
                                                if (e.target.value === 'no') {
                                                  formik.setFieldValue('accuralPeriod', null)
                                                  formik.setFieldValue('compoundingMethod', null)
                                                  formik.setFieldValue('rate', '')
                                                }
                                              }}
                                              value='no'
                                              width={48}
                                              height={48}
                                            />
                                            <label htmlFor='employee-no'>
                                              {formatMessage({ id: 'No' })}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Rate (Annual)' })}
                                        fieldName='rate'
                                        formik={formik}
                                        isDisabled={formik.values.convertibleInterestRate === 'no'}
                                        placeholder={formatMessage({ id: 'Enter Annual Rate' })}
                                        toolTipText={formatMessage({
                                          id: 'If conversion interest rate is applicable, specify the rate of interest on this Convertible Class.',
                                        })}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <SelectSearchInput
                                        label={formatMessage({ id: 'Accural Period' })}
                                        fieldName='accuralPeriod'
                                        placeholder={formatMessage({
                                          id: 'Select the accural period',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'Specify the interest accrual period for this Convertible Class.',
                                        })}
                                        options={accuralPeriodOptions}
                                        disabled={formik.values.convertibleInterestRate === 'no'}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <SelectSearchInput
                                        label={formatMessage({ id: 'Compounding Method' })}
                                        fieldName='compoundingMethod'
                                        placeholder={formatMessage({
                                          id: 'Select the compounding method',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'Select the compounding method to be used to calculate the interest for this Convertible Class.',
                                        })}
                                        options={compoundingMethodOptions}
                                        disabled={formik.values.convertibleInterestRate === 'no'}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {currentDocumentStep === 3 && (
                          <div className='w-100'>
                            <InfoCard2
                              title={formatMessage({ id: 'How to Add Convertible Class?' })}
                              desc={formatMessage({
                                id: `Add detailed Convertible Class information, including class type, name, prefix, conversion parameters, redemption parameters, and documents. These details help manage your cap table and investors more effectively on the ${brandingConfig.brandName} portal.`,
                              })}
                              slug={brandingConfig.helpLinks.addConvertibleClass}
                              className='w-100 mb-0'
                            />

                            <div className='mb-4'>
                              <div className='w-100 mt-10'>
                                {convertibleClassDetailsLoading ? (
                                  <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                      <div className='col-md-5 mb-10 mb-md-0'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                      <div className='col-md-5'>
                                        <div className='w-50'>
                                          <Skeleton
                                            height={20}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                        <div className='mt-2'>
                                          <Skeleton
                                            height={30}
                                            baseColor='var(--kt-skeleton-bg-color)'
                                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className='row'>
                                    <div className='col-md-6 col-12'>
                                      <SelectSearchInput
                                        label={formatMessage({ id: 'Seniority' })}
                                        fieldName='seniorityLevel'
                                        placeholder={formatMessage({
                                          id: 'Select the seniority ',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'Select a seniority parameter for redemption for this Convertible Class.',
                                        })}
                                        options={seniorityOptions}
                                        isTooltipForModal={true}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Multiplier' })}
                                        fieldName='multiplier'
                                        formik={formik}
                                        placeholder={formatMessage({ id: '1.0x' })}
                                        toolTipText={formatMessage({
                                          id: 'Add multiplier factor for this Convertible Class.',
                                        })}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Participating Cap' })}
                                        fieldName='participatingCap'
                                        formik={formik}
                                        placeholder={formatMessage({
                                          id: 'Enter the participating cap',
                                        })}
                                        toolTipText={formatMessage({
                                          id: 'Specify the participating cap for redemption for this Convertible Class.',
                                        })}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <SelectSearchInput
                                        label={formatMessage({ id: 'Convertible' })}
                                        fieldName='convertible'
                                        placeholder={formatMessage({
                                          id: 'Select the convertible',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'Specify how this Class will be convertible.',
                                        })}
                                        options={participatingOptions}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                      />
                                    </div>
                                    <div className=''>
                                      <div className='d-md-flex flex-md-column mb-8 px-3 px-md-0'>
                                        <div className='d-flex form-label  text-dark font-size-13'>
                                          {formatMessage({ id: 'Redemption Interest Rate' })}{' '}
                                          <ToolTipUIForModal
                                            tooltipText={formatMessage({
                                              id: 'Specify if redemption interest rate is applicable to this Convertible Class or not?',
                                            })}
                                          />
                                        </div>
                                        <div className='d-flex align-items-center gap-4'>
                                          <div className='d-flex align-items-center gap-1'>
                                            <input
                                              type='radio'
                                              id='redemption-yes'
                                              checked={
                                                formik.values.redemptionInterestRate === 'yes'
                                              }
                                              name='redemptionInterestRate'
                                              onChange={formik.handleChange}
                                              value='yes'
                                              width={48}
                                              height={48}
                                            />
                                            <label htmlFor='redemption-yes'>
                                              {formatMessage({ id: 'Yes' })}
                                            </label>
                                          </div>
                                          <div className='d-flex align-items-center gap-1'>
                                            <input
                                              type='radio'
                                              id='redemption-no'
                                              name='redemptionInterestRate'
                                              checked={
                                                formik.values.redemptionInterestRate === 'no'
                                              }
                                              onChange={(e) => {
                                                formik.handleChange(e)
                                                if (e.target.value === 'no') {
                                                  formik.setFieldValue(
                                                    'redemptionAccrualPeriod',
                                                    null
                                                  )
                                                  formik.setFieldValue(
                                                    'redemptionCompoundingMethod',
                                                    null
                                                  )
                                                  formik.setFieldValue('redemptionRate', '')
                                                }
                                              }}
                                              value='no'
                                              width={48}
                                              height={48}
                                            />
                                            <label htmlFor='redemption-no'>
                                              {formatMessage({ id: 'No' })}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <TextInput
                                        fieldType='number'
                                        label={formatMessage({ id: 'Rate (Annual)' })}
                                        fieldName='redemptionRate'
                                        formik={formik}
                                        isDisabled={formik.values.redemptionInterestRate === 'no'}
                                        placeholder={formatMessage({ id: 'Enter Annual Rate' })}
                                        toolTipText={formatMessage({
                                          id: 'If conversion interest rate is applicable, specify the rate of interest on this Convertible Class.',
                                        })}
                                        isTooltipForModal={true}
                                        onBlur={formik.handleBlur}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <SelectSearchInput
                                        label={formatMessage({ id: 'Accural Period' })}
                                        fieldName='redemptionAccrualPeriod'
                                        placeholder={formatMessage({
                                          id: 'Select the accural period',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'Specify the interest accrual period for this Convertible Class.',
                                        })}
                                        options={accuralPeriodOptions}
                                        disabled={formik.values.redemptionInterestRate === 'no'}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                      />
                                    </div>
                                    <div className='col-md-6 col-12'>
                                      <SelectSearchInput
                                        label={formatMessage({ id: 'Compounding Method' })}
                                        fieldName='redemptionCompoundingMethod'
                                        placeholder={formatMessage({
                                          id: 'Select the compounding method',
                                        })}
                                        formik={formik}
                                        toolTipText={formatMessage({
                                          id: 'Select the compounding method to be used to calculate the interest for this Convertible Class.',
                                        })}
                                        options={compoundingMethodOptions}
                                        disabled={formik.values.redemptionInterestRate === 'no'}
                                        isStarRequired={true}
                                        isTooltipForModal={true}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}

                        {/* Step 4  */}
                        {currentDocumentStep === 4 && (
                          <div className='w-100'>
                            <InfoCard2
                              title={formatMessage({ id: 'How to Add Convertible Class?' })}
                              desc={formatMessage({
                                id: `Add detailed Convertible Class information, including class type, name, prefix, conversion parameters, redemption parameters, and documents. These details help manage your cap table and investors more effectively on the ${brandingConfig.brandName} portal.`,
                              })}
                              slug={brandingConfig.helpLinks.addConvertibleClass}
                              className='w-100 mb-0'
                            />

                            <div className=''>
                              <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                {formatMessage({ id: 'Attach files' })}
                                <ToolTipUIForModal
                                  tooltipText={formatMessage({
                                    id: 'Upload/Add documents related to this Convertible Class like Promissory Note, Note to Purchase Agreement, etc.',
                                  })}
                                />
                              </div>
                              <div className='w-100'>
                                <button
                                  className='btn btn-primary border border-1 mb-2 px-6 py-4 text-center w-100 w-md-auto'
                                  onClick={() => setModelStatus(true)}
                                >
                                  {formatMessage({ id: 'Import Files' })}
                                </button>
                              </div>
                            </div>

                            <div className='mb-4'>
                              {files.length > 0 && (
                                <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                  {formatMessage({ id: 'Uploaded Files' })}{' '}
                                  <ToolTipUIForModal
                                    tooltipText={formatMessage({
                                      id: 'Manage all the uploaded documents here.',
                                    })}
                                  />
                                </div>
                              )}
                              <FileUpload
                                fileSize={parseInt(
                                  process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE as string
                                )}
                                maxFileNumber={10}
                                allowType={allowedFileTypes}
                                metaData={{ module: 'document', isProtected: false }}
                                modalStatus={modelStatus}
                                handleClose={() => {
                                  TagManager.dataLayer({
                                    dataLayer: {
                                      event:
                                        GTMEvent.ConvertibleSecurityClassCreateOrUpdateDocumentsUploadFailed,
                                      action: 'normal',
                                      metadata: {
                                        company_id: companyId,
                                        user_id: currentUser?.userId,
                                        email: currentUser?.email,
                                      },
                                    },
                                  })
                                  setModelStatus(false)
                                }}
                                handleSuccess={(id: number, name: string) => {
                                  setIsNotInitiaized(false)

                                  setFiles((prevFiles: any) => [...prevFiles, { id, name }])

                                  if (formikRef.current) {
                                    const currentFileIds = Array.isArray(
                                      formikRef.current.values.fileIds
                                    )
                                      ? formikRef.current.values.fileIds
                                      : []

                                    fileRef.current.push(id) // Store only the current ID
                                    const uniqueFileIds = Array.from(
                                      new Set([...currentFileIds, ...fileRef.current])
                                    )
                                    formikRef.current.setFieldValue('fileIds', uniqueFileIds)
                                    TagManager.dataLayer({
                                      dataLayer: {
                                        event:
                                          GTMEvent.ConvertibleSecurityClassCreateOrUpdateDocumentsUploadSuccessful,
                                        action: 'normal',
                                        metadata: {
                                          company_id: companyId,
                                          user_id: currentUser?.userId,
                                          email: currentUser?.email,
                                          document_name: name,
                                          document_id: id,
                                        },
                                      },
                                    })
                                  }
                                }}
                                resourceType='all'
                              />
                              {convertibleClassDetailsLoading ? (
                                <>
                                  <div className='w-50'>
                                    <Skeleton
                                      width={'100%'}
                                      height={48}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='w-50'>
                                    <Skeleton
                                      width={'100%'}
                                      height={48}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </>
                              ) : (
                                <div className='w-100'>
                                  <ul className='p-0 m-0'>
                                    {files?.map((file: any) => (
                                      <li
                                        key={file.id}
                                        className='d-flex align-items-center gap-2 text-decoration-none mb-3 w-100 border border-1 p-2'
                                      >
                                        <div className='d-flex justify-content-between align-items-center w-100'>
                                          <div className='w-100 d-flex align-items-center gap-2'>
                                            <img
                                              src={getFileType(file.name)}
                                              alt={file.name}
                                              style={{ height: '30px', width: '30px' }}
                                            />

                                            <p className='p-0 m-0 max-file-width'>
                                              {file.name.split('/').pop()}
                                            </p>
                                          </div>

                                          <button
                                            type='button'
                                            className='btn btn-secondry p-0 m-0  d-flex align-items-start'
                                            onClick={() => {
                                              setDeleteFileId(file.id)
                                              setDeleteShowModal(true)
                                            }}
                                          >
                                            <img src={deleteicon} alt='Delete' />
                                          </button>
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer className='container px-0'>
                  <div className='d-flex flex-md-row flex-column justify-content-md-end justify-content-center gap-3 w-100'>
                    {currentDocumentStep > 1 ? (
                      <div>
                        <button
                          type='button'
                          className='btn bg-light custom-button-property text-muted w-100'
                          onClick={prevStep}
                        >
                          {formatMessage({ id: 'Back' })}
                        </button>
                      </div>
                    ) : (
                      <div>
                        <button
                          type='button'
                          className='btn bg-light custom-button-property text-muted w-100'
                          onClick={() => setIsActive()}
                        >
                          {formatMessage({ id: 'Cancel' })}
                        </button>
                      </div>
                    )}
                    <div>
                      {currentDocumentStep < 4 ? (
                        <button
                          type='button'
                          className='btn bg-primary text-white custom-button-property w-100'
                          disabled={!formik.isValid}
                          onClick={nextStep}
                        >
                          {formatMessage({ id: 'Next' })}
                        </button>
                      ) : (
                        <button
                          type='submit'
                          className='btn bg-primary text-white custom-button-property w-100'
                          disabled={!formik.isValid || isLoading}
                          onClick={formik.submitForm}
                        >
                          {!isLoading && (
                            <span className='indicator-label font-size-13 p-0'>
                              {formatMessage({ id: 'Submit' })}
                            </span>
                          )}
                          {isLoading && (
                            <span className='indicator-label font-size-13 p-0'>
                              {formatMessage({ id: 'Please wait...' })}
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </Modal.Footer>
              </Modal>
            </Form>
          )
        }}
      </Formik>
      <DeleteFileConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={deleteLoading}
        header='Delete File'
        paragraph='Are you sure you want to delete this file?'
      />
    </>
  )
}
